import { H3, Text } from 'ds/components/typography';
import styled from '@emotion/styled';

export const PricesWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

export const PricesBorder = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.small};
  background-color: ${props => props.theme.colors.neutrals.white};
  border: solid 1px ${props => props.theme.colors.neutrals.grey8};
  &:empty {
    display: none;
  }
`;

export const PriceHistoryHeading = styled(H3)`
  padding: ${({ theme }) => `${theme.spacing(3)}`};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: ${theme.spacing(2)};
  `}
`;

export const TooltipText = styled(Text)`
  a {
    color: ${({ theme }) => theme.colors.brand.main};
    &:hover {
      color: ${({ theme }) => theme.colors.brand.dark};
    }
    &:focus {
      color: ${({ theme }) => theme.colors.brand.darker}
    }
  }
`;

export const Question = styled.div`
  ${({ theme }) => `
    padding: ${theme.spacing(0.5)};
    cursor: pointer;
    > svg {
      display: block;
      path {
        fill: ${theme.colors.neutrals.grey3};
      }
    }
  `}
`;
